import { useId } from 'react';
import { useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TaskTypeStatus } from '@econtractor/types';
import { TaskStatusBadge } from 'modules/task';
import ReportExecutorSelect from '../ReportFilterFields/ReportExecutorSelect';

const statuses = [TaskTypeStatus.NEW, TaskTypeStatus.INWORK, TaskTypeStatus.COMPLETED, TaskTypeStatus.ACCEPTED];

const OffReportTasksFilterForm = () => {
    const { t } = useTranslation('Reports');
    const { values, setFieldValue } = useFormikContext<{ statuses: number[]; showZeroTasks: boolean }>();
    const id = useId();
    return (
        <>
            <div className="mb-3 d-flex flex-column gap-2">
                <label className="form-label text-muted fs-12 mb-1">{t('tasksFilter.title')}</label>
                {statuses.map((status) => (
                    <Form.Check key={status} id={`${id}-${status}`} type="checkbox" label={<TaskStatusBadge status={status} />} checked={values.statuses.includes(status)} onChange={(event) => void setFieldValue('statuses', event.target.checked ? [...values.statuses, status] : values.statuses.filter((value) => value !== status))} />
                ))}
                <Form.Check id={`${id}-zero`} type="checkbox" label={t('tasksFilter.showZero')} checked={values.showZeroTasks} onChange={(event) => void setFieldValue('showZeroTasks', event.target.checked)} />
            </div>
            <ReportExecutorSelect />
        </>
    );
};

export default OffReportTasksFilterForm;
